// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import the CSS file
import App from './App';
import { registerServiceWorker } from './pwa/registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The BREC app: one service worker for the whole site (static files only; see client/public/sw.js).
registerServiceWorker();
